<template>
  <b-row>
    <b-col>
      <main >
        <h1>Partners List</h1>
        <ul class="partners-list">
        </ul>
      </main>
    </b-col>
  </b-row>
</template>

<script>
/* eslint-disable new-cap */
import axios from 'axios'

export default {
  data () {
    return {
      partners: ''
    }
  },
  mounted () {
    this.getPartnersList()
  },
  methods: {
    getPartnersList () {
      axios({
        method: 'post',
        url: 'https://core.platform.ue.co/public/partner-names?vertical=rewards'
      })
        .then((response) => {
          let partners = response.data
          let html = ''
          partners.forEach(partner => {
            let htmlSegment = `<li>${partner}</li>`
            html += htmlSegment
          })
          let container = document.querySelector('.partners-list')
          container.innerHTML = html
        })
        .catch((error) => {
          console.error(error)
        })
    }
  },
  components: {}
}
</script>
<style lang="less">
.partners-list {
  list-style: none;
  text-align: left;
}
</style>
